export const ACCEPTED_IMAGE_FORMATS = 'image/jpeg,image/png,image/jpg,image/svg+xml,image/x-icon';
